import React from 'react';
import { Typography } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { t } from '../../../i18n/i18n';
import BaseModalStrategy from './BaseModalStrategy';

const { Title } = Typography;

class DefaultStrategy extends BaseModalStrategy {
  renderBody() {
    if (!this.selectedNode || !this.selectedNode?.template) {
      return null;
    }

    return (
      <>
        <Title level={5}>
          <SettingOutlined /> {t('ALKYMATION_PARAMETERS')}
        </Title>

        {this.renderParameterFormItems(this.selectedNode?.template?.parameters)}
      </>
    );
  }
}

export default DefaultStrategy;
